import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TopActionBar from "./TopActionBar";
import { useNavigate } from "react-router-dom";
import { AuthState } from "../context/AuthProvider";
import { SocketState } from "../context/SocketProvider";
import { SET_MAIN_LOADER } from "../redux/loaderSlice";
import { SHOW_MAIN_ERROR_MODAL } from "../redux/errorMessageSlice";
import { SHOW_MAIN_SUCCESS_MODAL } from "../redux/successMessageSlice";

const LayoutCreateUser = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userDetail } = AuthState();
    const { socket } = SocketState();
    const [userList, setUserList] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [showTxnPopup, setShowTxnPopup] = useState(false);
    const [txnUser, setTxnUser] = useState(null);
    const TXN_PAGE_LIMIT = 10;

    const [txnPage, setTxnPage] = useState(0);
    const [txnHasMore, setTxnHasMore] = useState(true);
    const [txnLoading, setTxnLoading] = useState(false);

    const [transactions, setTransactions] = useState([]);
    const [editingUser, setEditingUser] = useState(null);

    const [form, setForm] = useState({
        display_user_name: "",
        user_name: "",
        password: "",
        whatsapp_number: "",
        user_type: "PLAYER",
        reporting_under: "R2",
        active: true,
    });

    useEffect(() => {
        if (!socket) return;
        socket.emit("req", {
            en: "USER_LISTS",
            data: {},
        });
    }, [socket]);

    // ---------- HANDLE INPUT ----------
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({ ...form, [name]: type === "checkbox" ? checked : value });
    };

    // ---------- SUBMIT ----------
    const handleSubmit = () => {
        if (!form.user_name || (!form.password && !editingUser)) {
            alert("User ID & Password required");
            return;
        }
        dispatch(SET_MAIN_LOADER(true));

        if (editingUser) {
            // Editing existing user
            socket.emit("req", {
                en: "USER_EDIT_INFO",
                data: {
                    user_id: editingUser._id,
                    update_field: {
                        display_user_name: form.display_user_name,
                        whatsapp_number: form.whatsapp_number,
                        ...(form.password && { password: form.password }), // update password only if entered
                    },
                },
            });
        } else {
            // Creating new user
            socket.emit("req", {
                en: "CREATE_USER",
                data: {
                    display_user_name: form.display_user_name,
                    user_name: form.user_name,
                    password: form.password,
                    whatsapp_number: form.whatsapp_number,
                },
            });
        }
    };

    const toggleUserActive = (user) => {
        socket.emit("req", {
            en: "USER_ACTIVE",
            data: {
                user_id: user._id,
                is_block: user.flags?.is_block == 0 ? true : false,
            },
        });
    };

    const confirmDelete = () => {
        socket.emit("req", {
            en: "USER_DELETE",
            data: { user_id: deleteUserId },
        });
        setShowDeletePopup(false);
        setDeleteUserId(null);
    };

    const cancelDelete = () => {
        setShowDeletePopup(false);
        setDeleteUserId(null);
    };

    // ---------- SOCKET RESPONSE ----------
    useEffect(() => {
        if (!socket) return;

        const handleSocketResponse = (res) => {

            switch (res.en) {
                case "USER_LISTS":
                    if (!res.err) {
                        setUserList(res.data?.lists || []);
                    }
                    break;

                case "CREATE_USER":
                    dispatch(SET_MAIN_LOADER(false));
                    if (!res.err) {
                        dispatch(SHOW_MAIN_SUCCESS_MODAL(res.msg));
                        socket.emit("req", { en: "USER_LISTS", data: {} });
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;

                case "USER_ACTIVE":
                    if (!res.err) {
                        // ✅ ONLY refresh list
                        socket.emit("req", { en: "USER_LISTS", data: {} });
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;

                case "USER_DELETE":
                    if (!res.err) {
                        socket.emit("req", { en: "USER_LISTS", data: {} });
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;

                case "USER_GET_INFO":
                    dispatch(SET_MAIN_LOADER(false));
                    if (!res.err) {
                        const userData = res.data; // data returned by server
                        setForm({
                            display_user_name: userData.display_user_name || "",
                            user_name: userData.user_name || "",
                            password: userData.password, // keep blank
                            whatsapp_number: userData.whatsapp_number || "",
                        });
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;


                case "USER_TRANSATIONS_LISTS":
                    if (!res.err) {
                        const newList = res.data?.list || [];

                        setTransactions(newList);

                        // ✅ agar records limit se kam aaye → no next page
                        setTxnHasMore(newList.length >= TXN_PAGE_LIMIT);

                        setTxnLoading(false);
                    } else {
                        setTxnLoading(false);
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;


                case "  ":
                    dispatch(SET_MAIN_LOADER(false));
                    if (!res.err) {
                        dispatch(SHOW_MAIN_SUCCESS_MODAL(res.msg));
                        socket.emit("req", { en: "USER_LISTS", data: {} });
                        setForm({ display_user_name: "", user_name: "", password: "", whatsapp_number: "" });
                        setEditingUser(null);
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;



                default:
                    break;
            }
        };

        socket.on("res", handleSocketResponse);
    }, [socket]);

    const openDeletePopup = (userId) => {
        setDeleteUserId(userId);
        setShowDeletePopup(true);
    };

    const openTransactionPopup = (user) => {
        setTxnUser(user);
        setShowTxnPopup(true);

        setTransactions([]);
        setTxnPage(0);
        setTxnHasMore(true);

        fetchTransactions(user, 0); // ✅ FIRST CALL WORKS
    };



    const handleEditUser = (user) => {
        setEditingUser(user); // store user to edit
        dispatch(SET_MAIN_LOADER(true));

        // Request latest user info from server
        socket.emit("req", {
            en: "USER_GET_INFO",
            data: { user_id: user._id },
        });
    };

    const fetchTransactions = (user, page) => {
        if (!user?._id) return;

        setTxnLoading(true);

        socket.emit("req", {
            en: "USER_TRANSATIONS_LISTS",
            data: {
                user_id: user._id,
                page
            }
        });
    };


    return (
        <>
            <TopActionBar />

            {/* ===== MAIN CONTAINER ===== */}
            <div className="main-container">
                {/* ===== LEFT FORM ===== */}
                <div className="left-panel">
                    <h3>Create User</h3>

                    <input
                        name="user_name"
                        placeholder="User ID"
                        value={form.user_name}
                        onChange={handleChange}
                    />
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={form.password}
                        onChange={handleChange}
                    />
                    <input
                        name="display_user_name"
                        placeholder="Name"
                        value={form.display_user_name}
                        onChange={handleChange}
                    />
                    <input
                        name="whatsapp_number"
                        placeholder="WhatsApp No"
                        value={form.whatsapp_number}
                        onChange={handleChange}
                    />

                    <div className="btn-row">
                        <button className="btn-save" onClick={handleSubmit}>
                            Save
                        </button>
                        <button
                            className="btn-clear"
                            onClick={() =>
                                setForm({
                                    display_user_name: "",
                                    user_name: "",
                                    password: "",
                                    whatsapp_number: "",
                                })
                            }
                        >
                            Clear
                        </button>
                    </div>
                </div>

                {/* ===== RIGHT TABLE ===== */}
                <div className="right-panel">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>User ID</th>
                                <th>Reporting</th>
                                <th>Balance</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userList.map((u, i) => (
                                <tr key={u._id}>
                                    <td>{i + 1}</td>
                                    <td>{u.display_user_name}</td>
                                    <td>{u.user_name}</td>
                                    <td>{userDetail?.user_name || "-"}</td>
                                    <td>{u.chips + u.game_winning || 0}</td>
                                    <td>
                                        <button
                                            style={{
                                                background: "#ff9800",
                                                color: "#fff",
                                                padding: "2px 6px",
                                                marginRight: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleEditUser(u)}
                                        >
                                            EDIT
                                        </button>
                                        {" "}
                                        <button
                                            style={{
                                                background: u.flags?.is_block === 0 ? "green" : "red",
                                                color: "#fff",
                                                padding: "2px 6px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => toggleUserActive(u)}
                                        >
                                            {" "}
                                            {u.flags?.is_block === 0 ? "BLOCK" : "BLOCKED"}{" "}
                                        </button>{" "}
                                        {/* <button
                                            style={{
                                                background: "red",
                                                color: "#fff",
                                                padding: "2px 6px",
                                                marginRight: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => openDeletePopup(u._id)}
                                        >
                                            DELETE
                                        </button> */}
                                        <button
                                            style={{
                                                background: "#2196f3",
                                                color: "#fff",
                                                padding: "2px 6px",
                                                marginRight: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => openTransactionPopup(u)}
                                        >
                                            TXN
                                        </button>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showDeletePopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h4>Confirm Delete</h4>
                        <p>Are you sure you want to delete this user?</p>

                        <div className="popup-actions">
                            <button className="btn-confirm" onClick={confirmDelete}>
                                OK
                            </button>
                            <button className="btn-cancel" onClick={cancelDelete}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showTxnPopup && (
                <div className="popup-overlay">
                    <div className="popup-box" style={{ width: "700px" }}>
                        <h4>
                            Transactions : {txnUser?.display_user_name} ({txnUser?.user_name})
                        </h4>

                        <div
                            style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                                marginTop: "10px",
                                border: "1px solid #ccc"
                            }}
                        >
                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Game ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((t, i) => (
                                        <tr key={t.id || i}>
                                            <td>{t.trnx_type_txt}</td>
                                            <td>{t.trnx_amount}</td>
                                            <td>{t.game_id || "-"}</td>
                                        </tr>
                                    ))}

                                    {txnLoading && (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                Loading...
                                            </td>
                                        </tr>
                                    )}

                                    {!txnHasMore && (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                No More Records
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                                alignItems: "center"
                            }}
                        >
                            <button
                                disabled={txnPage === 0 || txnLoading}
                                onClick={() => {
                                    const prev = txnPage - 1;
                                    setTxnPage(prev);
                                    fetchTransactions(txnUser, prev);
                                }}
                            >
                                ⬅ Prev
                            </button>

                            <span>Page {txnPage + 1}</span>

                            <button
                                disabled={!txnHasMore || txnLoading}
                                onClick={() => {
                                    const next = txnPage + 1;
                                    setTxnPage(next);
                                    fetchTransactions(txnUser, next);
                                }}
                            >
                                Next ➡
                            </button>

                        </div>



                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                            <button
                                className="btn-cancel"
                                onClick={() => setShowTxnPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}



            {/* ===== CSS ===== */}
            <style>{`
                .main-container {
                    display: flex;
                    gap: 10px;
                    padding: 10px;
                }

                .left-panel {
                    flex: 1;
                    background: #bfe3f2;
                    padding: 15px;
                    border-radius: 4px;
                }

                .left-panel h3 {
                    margin-bottom: 10px;
                }

                .left-panel input {
                    width: 100%;
                    padding: 8px;
                    margin-bottom: 8px;
                    border: 1px solid #999;
                }

                .btn-row {
                    display: flex;
                    gap: 10px;
                }

                .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.popup-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    width: 300px;
    text-align: center;
}

.popup-box h4 {
    margin-bottom: 10px;
}

.popup-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.btn-confirm {
    background: red;
    color: #fff;
    padding: 6px 14px;
    border: none;
    cursor: pointer;
}

.btn-cancel {
    background: #ccc;
    padding: 6px 14px;
    border: none;
    cursor: pointer;
}

                .btn-save {
                    background: green;
                    color: #fff;
                    padding: 8px;
                    flex: 1;
                    border: none;
                }

                .btn-clear {
                    background: orange;
                    padding: 8px;
                    flex: 1;
                    border: none;
                }

                .right-panel {
                    flex: 1.5;
                    overflow-x: auto;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    background: #fff;
                }

                th, td {
                    border: 1px solid #ccc;
                    padding: 6px;
                    font-size: 14px;
                    text-align: left;
                }

                th {
                    background: #e0e0e0;
                }

                /* ===== MOBILE RESPONSIVE ===== */
                @media (max-width: 768px) {
                    .main-container {
                        flex-direction: column;
                    }

                    th, td {
                        font-size: 12px;
                        padding: 4px;
                    }
                }
            `}</style>
        </>
    );
};

export default LayoutCreateUser;
